import { CurrencyType } from '@soposopo/sopo-models';

export type RingPointResetFrequency = 'daily' | 'weekly';

export const DEFAULT_NECESSARY_POINTS = 200;
export const DEFAULT_RING_POINT_RESET_FREQUENCY: RingPointResetFrequency = 'daily';
export const DEFAULT_RING_POINT_RESET_TIME = '7:30PM EST';

const RING_POINTS_TITLE_DAILY = 'Daily Ring Points';
const RING_POINTS_TITLE_WEEKLY = 'Weekly Ring Points';

/**
 * Section title shown above the points progress bar / popup contents.
 */
export function composeRingPointTitle(frequency: RingPointResetFrequency): string {
    return frequency === 'weekly' ? RING_POINTS_TITLE_WEEKLY : RING_POINTS_TITLE_DAILY;
}

/**
 * Build the body message rendered above the points progress bar.
 * Switches between daily/weekly wording and Gold/Sweeps currency word.
 */
export function composeRingPointMessage(
    frequency: RingPointResetFrequency,
    currency: CurrencyType,
): string {
    const currencyWord = currency === CurrencyType.GOLD ? 'Gold' : 'Sweeps';
    if (frequency === 'weekly') {
        return `Earn enough points each week in SOPO ${currencyWord} Ring Games to qualify the weekly freeroll!`;
    }
    return `Earn enough points each day in SOPO ${currencyWord} Ring Games to qualify the nightly freeroll!`;
}

/**
 * Build the small reset-info line shown at the bottom of the eligibility card.
 * `resetTime` is the editable suffix from Firestore (e.g. "7:30PM EST" or "ON SUNDAY AT 7:30PM EST").
 */
export function composeRingPointResetInfo(
    frequency: RingPointResetFrequency,
    resetTime: string,
): string {
    return frequency === 'weekly'
        ? `RESETS WEEKLY ${resetTime}`
        : `RESETS DAILY AT ${resetTime}`;
}
